import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Input, InputNumber, Col, Select, Button, Spin } from 'antd';

import i18n from 'services/i18n';
import { NUMERIC_FIELD, NUMERIC_SIGN, FILTER_TYPE } from 'constants/options';

@i18n('form')
@Form.create()
class NumericFilter extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    form: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
  };

  static defaultProps = {
    loading: false,
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const data = {
          criterion: { ...values },
        };
        this.props.onSubmit(FILTER_TYPE.NUMERIC, data);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <Spin spinning={this.props.loading}>
        <Form
          className="criteria-form"
          layout="horizontal"
          onSubmit={this.handleSubmit}
        >
          <Form.Item wrapperCol={{ span: 24 }} className="form-full-width">
            {getFieldDecorator('field', {
              initialValue: 'AGE',
            })(
              <Select placeholder={this.props.translate('chooseProperty')}>
                {NUMERIC_FIELD.map(item => (
                  <Select.Option key={item.value} value={item.value}>
                    {this.props.translate(item.value)}
                  </Select.Option>
                ))}
              </Select>,
            )}
          </Form.Item>
          <Input.Group>
            <Col span={12}>
              <Form.Item>
                {getFieldDecorator('sign', {
                  initialValue: 'OVER',
                })(
                  <Select placeholder={this.props.translate('chooseOperation')}>
                    {NUMERIC_SIGN.map(item => (
                      <Select.Option key={item.value} value={item.value}>
                        {item.title}
                      </Select.Option>
                    ))}
                  </Select>,
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item>
                {getFieldDecorator('value', {
                  initialValue: 0,
                })(<InputNumber min={0} precision={0} />)}
              </Form.Item>
            </Col>
          </Input.Group>
          <Button htmlType="submit" icon="plus" className="add-btn">
            {this.props.translate('add')}
          </Button>
        </Form>
      </Spin>
    );
  }
}

export default NumericFilter;
